<template>
  <div class="ContentHomeSlider pattern-slider">
    <transition
      :duration="500"
      name="fade"
    >
      <ContentHomeSliderItem
        :id="activeElementNumber"
        :key="activeElementNumber"
        :image-path="activeImagePath"
        class="pattern-slider__image"
        :tablet="isBigTablet"
        :safari="isSafari"
      />
    </transition>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onBeforeUnmount, onMounted, ref } from 'vue';
import { useDeviceSize, useDeviceBrowser } from 'Store';
import ContentHomeSliderItem from './ContentHomeSliderItem.vue';

const IMAGES: string[] = [];

const context1 = require.context('images/pattern-slider', false, /\.(png|jpe?g|gif|svg)$/);
context1.keys().forEach(img => IMAGES.push(context1(img)));

export default defineComponent({
  name: 'ContentHomeSlider',
  components: {
    ContentHomeSliderItem,
  },
  emits: ['slider-image-change', 'current-slide-change'],
  setup(props, { emit }) {
    let intervalId = 0;
    const { isBigTablet } = useDeviceSize();
    const { isSafari } = useDeviceBrowser();

    const activeElementNumber = ref(1);
    const activeImagePath = computed(() => IMAGES?.find((item, key) => key === activeElementNumber.value - 1));
    function setActivePage() {
      const active = IMAGES.length > activeElementNumber.value ? activeElementNumber.value + 1 : 1;
      activeElementNumber.value = active;
    }
    function emitImageChange() {
      const imageUrl = IMAGES.find((item, key) => key === activeElementNumber.value - 1);
      emit('slider-image-change', imageUrl);
      emit('current-slide-change', activeElementNumber);
    }

    function setAutoPlay() {
      intervalId = setInterval(() => {
        setActivePage();
        emitImageChange();
      }, 7000);
    }

    onMounted(() => {
      setAutoPlay();
    });

    onBeforeUnmount(() => {
      clearInterval(intervalId);
    });
    emitImageChange();
    return {
      activeElementNumber,
      isBigTablet,
      isSafari,
      activeImagePath,
    };
  },
});
</script>
<style lang="sass" scoped>
@import '~Styles/_variables'
.pattern-slider
  width: 100%
  height: 580px
  position: relative
  svg
    width: 100%
    height: 100%
    max-width: 560px
  &__image
    width: 560px
    position: absolute
    left: 0
    top: 0
.fade-enter-active,
.fade-leave-active
  transition: opacity 0.3s ease-out
  will-change: opacity
.fade-enter-from,
.fade-leave-to
  opacity: 0
  transition: opacity 1s ease-in
  will-change: opacity
</style>
